import {fetchBody, URL_CATEGORY_GET_LIST, URL_CATEGORY_ADD, URL_CATEGORY_GET_DETAIL, URL_CATEGORY_UPDATE} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getCategoryList ({mReqCategoryList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCategoryList, token}), 
      url: URL_CATEGORY_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addCategory ({mReqCategory, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCategory, token}), 
      url: mReqCategory.categoryId===""?URL_CATEGORY_ADD:URL_CATEGORY_UPDATE,
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getCategoryDetail ({mReqCategoryItem, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCategoryItem, token}), 
      url: URL_CATEGORY_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_updateCategory ({mReqUpdateDepartment, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqUpdateDepartment, token}), 
      url: URL_CATEGORY_UPDATE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
